import Image from 'next/image';
import React from 'react';
import DynamicFields from './DynamicFields';
import { ConsultFormContainer, FormInner, RequestCallbackBtn } from './styled';

const ConsultForm = (props) => {
  const {
    setShowSubmitted,
    productData,
    setBookingDone,
    formData,
    isConsultPage,
    setLeadId,
    fromPdp,
  } = props;

  const templateForm = (cardEffect) => {
    return (
      <>
        <p className="freeMsg">
          No charges and commitment-free. No spam, just genuine care.
        </p>
        <RequestCallbackBtn
          isConsultPage={isConsultPage}
          className={`${cardEffect}`}
        >
          REQUEST A CALLBACK <span></span>
        </RequestCallbackBtn>
      </>
    );
  };
  return (
    <>
      <ConsultFormContainer isConsultPage={isConsultPage}>
        <FormInner>
          <div className="circleImg">
            <Image
              src={
                'https://images.myloapp.in/NestJsUploads/1691738879528-1x1-circle-doctor-image.webp'
              }
              alt=""
              quality={90}
              fill
              sizes="33vw"
            />
          </div>
          <p className="greeting">Congrats on Taking the First Step!</p>
          <span>Let&apos;s Get Started on Your Path to a Healthier You!</span>
          <DynamicFields
            formData={formData}
            template={templateForm}
            skuName={productData?.name}
            skuId={productData?.id}
            setShowSubmitted={setShowSubmitted}
            setBookingDone={setBookingDone}
            setLeadId={setLeadId}
            fromPdp={fromPdp}
          />
        </FormInner>
      </ConsultFormContainer>
    </>
  );
};

export default ConsultForm;
